import React, { createContext, useReducer } from "react";
import PropTypes from "prop-types";

const initialState = {
  pricingDetails: {},
  isFetchingPricingDetails: false,
};

const StripeActions = {
  FETCH_PRICING_DETAILS: "FETCH_PRICING_DETAILS",
  FETCH_PRICING_DETAILS_SUCCESSFUL: "FETCH_PRICING_DETAILS_SUCCESSFUL",
  FETCH_PRICING_DETAILS_FAIL: "FETCH_PRICING_DETAILS_FAIL",
};

const reducer = (state, action) => {
  switch (action.type) {
    case StripeActions.FETCH_PRICING_DETAILS: {
      return { ...initialState, isFetchingPricingDetails: true };
    }

    case StripeActions.FETCH_PRICING_DETAILS_SUCCESSFUL: {
      const pricingDetails = action.value;
      return { ...initialState, pricingDetails };
    }

    case StripeActions.FETCH_PRICING_DETAILS_FAIL: {
      return { ...initialState, isFetchingPricingDetails: false };
    }
    default:
      return state;
  }
};

const StripeContext = createContext();

const StripeProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <StripeContext.Provider value={{ state, dispatch }}>
      {children}
    </StripeContext.Provider>
  );
};

StripeProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export { StripeActions, StripeContext, StripeProvider };
